import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { NavLink as NavLinkRRD } from "react-router-dom";
import Rating from "@mui/material/Rating";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Media,
  Button,
  NavItem,
  NavLink,
} from "reactstrap";
import Box from "@mui/material/Box";
import { connect } from "react-redux";
import { removeLogin } from "../../Redux/Creators/LoginCreatorss";
import LinearProgressWithCase from "../../../src/views/Components/SplitScreeen/AllTabs/ProjectDetails/LinearProgressWithCase";
import { useSelector } from "react-redux";
import { getTasksList } from "Redux/Creators/TaskCreators";
import { getUsersList } from "Redux/Creators/UsersCreators";
import { use } from "react";

const AdminNavbar = (props) => {
  const [progress, setProgress] = React.useState(0);
  const [collapseOpen, setCollapseOpen] = React.useState();
  const myState = useSelector((state) => state.AdminProgressBar);

  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  let barCount = props?.property?.property;

  const filteredKeys = Object.keys(barCount).filter((key) =>
    key.endsWith("Progress")
  );
  const filteredValues = filteredKeys.map((key) => barCount[key]);
  const sum =
    (filteredValues.reduce((acc, val) => +acc + +val, 0) /
      filteredValues.length) *
    100;
  console.log("filteredValues", filteredValues, barCount, sum);

  useEffect(() => {
    setProgress(sum);
    console.log("3322", props, myState);
  }, [props]);

  let tasks = props.tasks?.isLoading ? [] : props.tasks?.tasks?.tasks?.data;

  React.useEffect(() => {
    fetchData();
  }, []);

  const loggedInUserId = props?.login?.login?.user?.id;
  const currentUser = props?.users?.users?.data?.find(
    (u) => u.id === loggedInUserId
  );

  const userRating = parseFloat(currentUser?.rating || 0);

  console.log("useruserss", props?.users?.users?.data?.rating);
  console.log(currentUser, "currentUser");
  const fetchData = () => {
    const token = props.login?.login?.token;

    let data = {
      pageno: 1,
      pageSize: 1000000,
      token: token,
    };
    props.getTasksList(data);
    props.getUsersList(data);
  };

  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <Link
            className=" h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
            to={props.path}
          >
            {props.brandText}
          </Link>
          <Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            {props.brandText == "Work In Progress Casecc" ? (
              <div
                className="pb-4"
                style={{
                  width: "64vw",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <Box sx={{ width: "100%" }} style={{ width: "26vw" }}>
                  <LinearProgressWithCase value={progress} />
                </Box>
              </div>
            ) : (
              <div style={{ display: "flex", gap: "10px" }}>
                {/* ✅ Rating Stars */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Rating
                    name="api-rating"
                    value={userRating}
                    precision={0.1}
                    readOnly
                  />
                  {/* <span style={{ marginLeft: "5px", color: "#fff" }}>
                    {userRating.toFixed(2)}/5
                  </span> */}
                </div>
                <NavLink
                  to="/admin/task-management"
                  tag={NavLinkRRD}
                  onClick={closeCollapse}
                  activeClassName="active active2"
                >
                  <Button size="small" variant="contained" color="warning">
                    <strong>
                      Pending task:{" "}
                      {tasks?.filter((row) => row.status === "0").length}
                    </strong>
                  </Button>
                </NavLink>
                <NavLink
                  to="/admin/tickets"
                  tag={NavLinkRRD}
                  onClick={closeCollapse}
                  activeClassName="active active2"
                >
                  <Button size="small" variant="contained" color="info">
                    <strong>IT Support</strong>
                  </Button>
                </NavLink>
              </div>
            )}
          </Form>

          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src={
                        require("../../assets/img/theme/team-4-800x800.jpg")
                          .default
                      }
                    />
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">
                      Libra Valuers
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem>

                <DropdownItem divider />
                <DropdownItem href="#" onClick={() => props.removeLogin()}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    AdminProgressBar: state.AdminProgressBar,
    property: state.property,
    tasks: state.tasks,
    users: state.users,
    login: state.login,
  };
};

const mapDispatchToProps = (dispatch) => ({
  removeLogin: () => dispatch(removeLogin()),
  getTasksList: (data) => dispatch(getTasksList(data)),
  getUsersList: (data) => dispatch(getUsersList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbar);
